{
  "names": {
    "Fajr": "Fajr",
    "Dhuhr": "Dhuhr",
    "Asr": "Asr",
    "Maghrib": "Maghrib",
    "Isha": "Isha"
  },
  "card": {
    "label": "Falja tjetër",
    "labelTomorrow": "Nesër · {{prayer}}",
    "inHoursMinutes": "për {{hours}} o {{minutes}} min",
    "inMinutes": "për {{minutes}} min",
    "open_aria": "Hap oraret e faljes",
    "pro": "Rhemn Pro",
    "unlock_aria": "Zhblloko oraret e faljes me Rhemn Pro",
    "unavailable": "Oraret e faljes nuk janë të disponueshme tani."
  },
  "sheet": {
    "bellOn_aria": "Çaktivizo kujtuesin e {{prayer}}",
    "bellOff_aria": "Aktivizo kujtuesin e {{prayer}}",
    "explainer": "Merr një kujtues të butë në çdo falje. Kujtuesit janë njoftime të heshtura — pa zë si parazgjedhje.",
    "enableReminders": "Aktivizo kujtuesit",
    "enableInSettings": "Aktivizo njoftimet e Rhemn te Cilësimet për të marrë kujtuesit e faljes.",
    "openSettings": "Hap Cilësimet"
  },
  "notifications": {
    "body": "Erdhi koha e faljes."
  },
  "focus": {
    "label": "Namazi i {{prayer}}",
    "close_aria": "Mbyll ekranin e namazit",
    "hint": "Shtyp Esc ose × për t'u kthyer",
    "phrases": {
      "accepted": "Allahu e pranoftë namazin tënd",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Fillo me qëllim. Vazhdo me bereqet.",
    "prayerApproaches": "Namazi yt i radhës po afrohet. Qëndro i ankoruar në qëllimin tënd.",
    "morningPursue": "Një mëngjes i bekuar për të ndjekur: {{focus}}",
    "dayCloses": "Ndërsa dita mbyllet, reflekto mbi: {{focus}}",
    "fulfilled": "E përmbushe qëllimin tënd sot. Elhamdulilah.",
    "workingTowards": "Sot po punon drejt: {{focus}}",
    "prayerNear": "Namazi yt i radhës është afër. Merr një frymë."
  },
  "widget": {
    "countdown": "pas {{time}}",
    "openToUpdate": "Hap Rhemn për ta përditësuar",
    "openForVerse": "Hap Rhemn për ajetin e sotëm"
  }
}
